<template>
  <div class='dialog-content'>
    <div class="kye-dialog-body">
      <kye-form :model="form" ref="form" label-width="42px" class="demo-form">
        <kye-form-item label="链接" prop="superLink"
          :rules="$rule.str('链接', true, 'change')">
          <kye-input v-model="form.superLink"></kye-input>
        </kye-form-item>
      </kye-form>
    </div>
    <div class="el-dialog__footer">
      <kye-button type="primary" @click="save">保 存(S)</kye-button>
      <kye-button @click="close">取 消</kye-button>
    </div>
  </div>
</template>
<script>
 export default {
  data() {
    return {
      form: {
        superLink: ''
      },
    }
  },
  methods: {
    async save() {
      if (this.form.superLink) {
        this.$emit('addLink', this.form.superLink)
        this.close()
        this.form.superLink = ''
      } else {
        this.$message.warning('请新增链接')
      }
    },
    close() {
      this.$emit('close')
    }
  }
 }
</script>
<style lang="scss" scoped>
.dialog-content {
  .kye-dialog-body {
    padding: 32px 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-editor-new/components/super-link.vue